import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			closeButton: {
				color: theme.palette.grey[400],
				display: "flex",
				justifyContent: "flex-end",
				webkitJustifyContent: "flex-end"
			},
			root: {
				height: "100vh",
				position: "relative"
			},
			rootBg: {
				position: "absolute",
				zIndex: 1,
				"&>img": {
					width: "100%",
					height: "30vh"
				}
			},
			rootCity: {
				position: "absolute",
				zIndex: 2,
				paddingTop: "10%",
				"&>img": {
					width: "100%",
					height: "50vh",
					objectFit: "none"
				}
			},
			bodyPage: {
				transform: "translate(0, -50%)",
				width: "100%",
				top: "50%",
				position: "absolute",
				zIndex: 3
			},
			title: {
				color: theme.palette.secondary.contrastText,
				fontSize: 17,
				fontWeight: 500,
				lineHeight: "26px",
				padding: "0px 40px"
			},
			subTitle: {
				color: "#777E96",
				fontSize: 13,
				padding: "0px 40px",
				marginTop: 15
			},
			driver: {
				borderTop: "1px dashed #9DB9E2",
				width: 118
			},
			rootBody: {
				borderRadius: 4,
				border: "1px solid #F3F6FB",
				padding: 10,
				margin: "0px 30px"
			},
			itemInfo: {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between"
			},
			titleInfo: {
				color: "#777E96",
				fontSize: 13,
				marginBottom: 10
			},
			info: {
				color: "#272E3A",
				fontSize: 13
			},
			rootFooter: {
				position: "fixed",
				bottom: 20,
				width: "100%",
				maxWidth: 444,
				textAlign: "center"
			},
			btnSubmit: {
				background: theme.palette.secondary.main,
				color: theme.palette.common.white,
				fontSize: 14,
				textTransform: "none",
				width: 196,
				height: 46,
				borderRadius: 6,
				"&:active": {
					opacity: 0.7,
					background: theme.palette.secondary.main
				},
				"&:hover": {
					background: theme.palette.secondary.main
				}
			},
			disabledBtn: {
				background: `${theme.palette.grey[900]} !important`,
				color: `${theme.palette.common.white} !important`
			}
		}),
	{
		name: "DialogSignatureSuccess",
		index: 1
	}
);

export default useStyles;
